import { useMutation } from "@tanstack/react-query";

import { requestSupport as requestSupportService } from "../services/requestSupport";
import { RequestSupportData } from "../types/RequestSupportData";

export const useSupportApi = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
}) => {
  const requestSupportMutation = useMutation({
    mutationFn: requestSupportService,
    onSuccess,
    onError,
  });

  const requestSupport = (data: RequestSupportData) => {
    requestSupportMutation.mutate(data);
  };

  return { requestSupport, requestSupportMutation };
};
